import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { languageNames } from '../locales/translations';
import { IoGlobeOutline, IoChevronDownOutline } from 'react-icons/io5';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { language, changeLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (e, newLanguage) => {
    e.preventDefault();
    e.stopPropagation();
    changeLanguage(newLanguage);
    setIsOpen(false);
  };

  return (
    <div className="language-selector">
      <button 
        className="language-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('language')}
      >
        <IoGlobeOutline size={16} />
        <span className="language-text">{languageNames[language]}</span>
        <IoChevronDownOutline size={12} className={`chevron ${isOpen ? 'open' : ''}`} />
      </button>
      
      {isOpen && (
        <div 
          className="language-dropdown"
          onClick={(e) => e.stopPropagation()}
        >
          {Object.entries(languageNames).map(([code, name]) => (
            <button
              key={code}
              className={`language-option ${code === language ? 'active' : ''}`}
              onClick={(e) => handleLanguageChange(e, code)}
            >
              {name}
            </button>
          ))}
        </div>
      )}
      
      {isOpen && (
        <div 
          className="language-overlay" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default LanguageSelector; 